/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listTimecardEnforcementSettings} from '../api'

export const useMutationListTimecardEnforcementSettings = createReactQueryMutationHook('listTimecardEnforcementSettings', listTimecardEnforcementSettings)
